import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import InvoiceTemplateManager from "../../apps/InvoiceTemplate/InvoiceTemplateManager";
import Header from "../../components/layout/Header";
import { toggleFullScreen } from "../../components/layout/functions/layout";
import Sidebar from "../../components/layout/Sidebar";

const InvoiceTemplates = ({ nav }) => {
  const navigate = useNavigate();
  const userLogin = useSelector((state) => state.userSignIn);
  const { userInfo } = userLogin;

  return (
    <div className={nav.isSidebar}>
      <Header nav={nav} />
      <Sidebar nav={nav} />
      <main className="page-content">
        <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
          <div className="breadcrumb-title pe-3">Settings</div>
          <div className="ps-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0 p-0">
                <li className="breadcrumb-item">
                  <Link to="/">
                    <i className="bx bx-home-alt" />
                  </Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Invoice Templates
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <hr />
        <InvoiceTemplateManager />
      </main>
      <div className="overlay nav-toggle-icon" />
      <a href="#" className="back-to-top">
        <i className="bx bxs-up-arrow-alt" />
      </a>
    </div>
  );
};

export default InvoiceTemplates;